module.exports = __webpack_public_path__ + "images/places/training_628-f0977dd93c40c58f31abd9b57e45404c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/training_628.jpg
 ** module id = 315
 ** module chunks = 0
 **/